
export enum DeliveryInfoRequiredCd {
	CAPTURED = 'Captured',
	NOT_RQRD = 'NotRqrd',
	RQRD = 'Rqrd'}

